{{ money.amount | currency: money.currency }}
